/*
 * 委托单流程
 */
export default [
  {
    name: 'BILL_CREATE',
    description: "创建委托单",
    operation: "创建委托单",
    completeText: "创建委托单",
    icon: "icon-chuangjian"
  },
  {
    name: 'BILL_CHECKED',
    description: "待审核",
    operation: "待审核",
    completeText: "已审核",
    icon: "icon-weituodandaishenhe",
    type: "lab"
  },
  {
    name: 'BILL_BACK',
    description: "待回传",
    operation: "待回传",
    completeText: "已回传",
    icon: "icon-weituodandaihuichuan",
    type: "lab"
  },
  {
    name: 'BILL_RECEIVE',
    description: "待接收",
    operation: "待接收",
    completeText: "已接收",
    icon: "icon-weituodandaijieshou",
    type: "lab"
  },
  {
    name: 'BILL_ASSIGN',
    description: "待分派",
    operation: "待分派",
    completeText: "已分派",
    icon: "icon-weituodandaifenpai",
    type: "lab"
  },
  {
    name: 'BILL_EXECUTE',
    description: "执行中",
    operation: "执行中",
    completeText: "已执行",
    icon: "icon-weituodanzhihangzhong",
    type: "lab"
  },
  {
    name: 'BILL_DELIVER',
    description: "待交付",
    operation: "待交付",
    completeText: "已交付",
    type: "report",
    icon: "icon-weituodandaijiaofu"
  },
  {
    name: 'BILL_COMPLETED',
    description: "已完成",
    operation: "已完成",
    completeText: "已完成",
    icon: "icon-yiwancheng"
  },
  {
    name: 'BILL_DELETE',
    description: "已关闭",
    operation: "已关闭",
    completeText: "已关闭",
    icon: "icon-dingdanguanbi"
  }
];
